module.exports = __webpack_public_path__ + "img/contest-info.4cea911c.webp";